import Helpers from '../../../../../../common/helpers/Helpers';
import Constants from '../../../../../../common/constants/Constants';

export const getReport = args => {
  return Helpers.get(`${Constants.OLDREPORTS_URL}`, {}, args);
};
